/**
 * premium-gallery.js — carousel: stage track, thumbs, dots, arrows, swipe,
 * variant sync via MutationObserver on .product-template[data-variant-id].
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initAll);

  function initAll() {
    document.querySelectorAll('[data-premium-gallery]').forEach(initGallery);
  }

  function initGallery(root) {
    var track = root.querySelector('[data-pmg-track]');
    var viewport = root.querySelector('[data-pmg-viewport]');
    var slides = root.querySelectorAll('[data-pmg-slide]');
    var thumbs = root.querySelectorAll('[data-pmg-thumb]');
    var dots = root.querySelectorAll('[data-pmg-dot]');
    var btnPrev = root.querySelector('[data-pmg-prev]');
    var btnNext = root.querySelector('[data-pmg-next]');

    var count = slides.length;
    if (!track || count === 0) return;

    var idx = 0;
    var touchStartX = null;

    var variantMap = {};
    var mapEl = root.querySelector('[data-pmg-variant-map]');
    try {
      if (mapEl && mapEl.textContent) variantMap = JSON.parse(mapEl.textContent);
    } catch (e) {}

    function clamp(i) {
      var n = count;
      return ((i % n) + n) % n;
    }

    function getSlideVideo(slide) {
      return slide.querySelector('video.pmg__video') || slide.querySelector('video');
    }

    function bindVideoUnmute(video) {
      if (!video || video.dataset.pmgUnmuteBound) return;
      video.dataset.pmgUnmuteBound = '1';
      video.addEventListener('play', function () {
        video.muted = false;
      });
      video.addEventListener('click', function () {
        video.muted = false;
        if (video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });
    }

    function syncVideos(activeIndex, opts) {
      slides.forEach(function (s, j) {
        var v = getSlideVideo(s);
        if (!v) return;
        if (j === activeIndex) {
          if (opts && opts.userAction) v.muted = false;
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          v.pause();
          try {
            v.currentTime = 0;
          } catch (e) {}
          v.muted = true;
        }
      });
    }

    slides.forEach(function (s) {
      bindVideoUnmute(getSlideVideo(s));
    });

    function goTo(i, opts) {
      opts = opts || {};
      idx = clamp(i);
      track.style.transform = 'translateX(-' + idx * 100 + '%)';

      if (opts.variantSync && root) {
        root.classList.add('pmg--variant-sync');
        window.clearTimeout(root._pmgVariantSyncT);
        root._pmgVariantSyncT = window.setTimeout(function () {
          root.classList.remove('pmg--variant-sync');
        }, 520);
      }

      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === idx);
      });

      thumbs.forEach(function (t, j) {
        var on = j === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && typeof t.scrollIntoView === 'function') {
          try {
            t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: opts.smoothScroll ? 'smooth' : 'auto' });
          } catch (err) {
            t.scrollIntoView(false);
          }
        }
      });

      dots.forEach(function (d, j) {
        var on = j === idx;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.setAttribute('tabindex', on ? '0' : '-1');
      });

      syncVideos(idx, opts);
    }

    function step(delta) {
      goTo(idx + delta, { smoothScroll: true, userAction: true });
    }

    if (btnPrev) btnPrev.addEventListener('click', function () {
      step(-1);
    });
    if (btnNext) btnNext.addEventListener('click', function () {
      step(1);
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var j = parseInt(t.getAttribute('data-pmg-thumb'), 10);
        if (!isNaN(j)) goTo(j, { smoothScroll: true, userAction: true });
      });
    });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var j = parseInt(d.getAttribute('data-pmg-dot'), 10);
        if (!isNaN(j)) goTo(j, { smoothScroll: true, userAction: true });
      });
    });

    if (viewport) {
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(idx - 1, { smoothScroll: true, userAction: true });
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(idx + 1, { smoothScroll: true, userAction: true });
        }
      });

      viewport.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function (e) {
          if (touchStartX == null) return;
          var dx = e.changedTouches[0].screenX - touchStartX;
          touchStartX = null;
          if (Math.abs(dx) < 48) return;
          if (dx > 0) goTo(idx - 1, { smoothScroll: true, userAction: true });
          else goTo(idx + 1, { smoothScroll: true, userAction: true });
        },
        { passive: true }
      );
    }

    function slideIndexForMediaId(mid) {
      if (mid == null || mid === '') return -1;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mid)) return i;
      }
      return -1;
    }

    function syncVariant(variantId, fromDomEvent) {
      if (!variantId || !variantMap || variantMap['' + variantId] == null) return;
      var mid = variantMap['' + variantId];
      var si = slideIndexForMediaId(mid);
      if (si >= 0) {
        goTo(si, {
          smoothScroll: !!fromDomEvent,
          variantSync: !!fromDomEvent,
          userAction: !!fromDomEvent
        });
      }
    }

    var productRoot =
      root.closest('[data-section-type="product-template"]') ||
      root.closest('.product-template');

    var startIdx = 0;
    if (productRoot) {
      var curVid = productRoot.getAttribute('data-variant-id');
      var curMid = variantMap && variantMap['' + curVid];
      var si0 = slideIndexForMediaId(curMid);
      if (si0 >= 0) startIdx = si0;
    }
    goTo(startIdx, { smoothScroll: false });

    if (productRoot) {
      try {
        var mo = new MutationObserver(function () {
          syncVariant(productRoot.getAttribute('data-variant-id'), true);
        });
        mo.observe(productRoot, { attributes: true, attributeFilter: ['data-variant-id'] });
      } catch (err) {}
    }
  }
})();
